<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-weight-bold">
        {{ $t('button.import_csv') }}
      </p>
    </header>
    <section class="modal-card-body">
      <b-field v-bind:label="$t('label.csv_columns_format')">
        <b-message type="is-info" :closable="false"
          >[uuid] [name] [geofence_sw_lat] [geofence_sw_lon] [geofence_ne_lat]
          [geofence_ne_lon] [geofence_angle] [geofence_map_zoom]
          [geofence_opacity]
        </b-message>
      </b-field>

      <b-field v-bind:label="$t('label.csv_file')">
        <b-upload v-model="csvFile" drag-drop expanded>
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-medium"></b-icon>
              </p>
              <p>{{ $t('messages.drop_file_here_or_select_a_file') }}</p>
            </div>
          </section>
        </b-upload>
      </b-field>

      <b-field v-if="csvFile">
        <b-tag
          size="is-medium"
          closable
          aria-close-label="Remove"
          @close="csvFile = null"
          >{{ csvFile.name }}</b-tag
        >
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button
        class="button has-text-weight-semibold"
        @click="handleCancelImportModal()"
      >
        {{ $t('button.cancel') }}
      </button>
      <button
        class="button is-info has-text-weight-bold"
        :disabled="!csvFile"
        @click="handleImportCSV()"
      >
        {{ $t('button.import') }}
      </button>
    </footer>
  </div>
</template>


<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {},
  computed: {},
})
export default class GeofenceCSVModal extends Vue {
  // Import/Export csv setting
  csvFile = null

  handleCancelImportModal() {
    this.$parent.close()
    this.csvFile = null
  }

  async handleImportCSV() {
    this.$store.dispatch('geofences/importCSV', this.csvFile).then(() => {
      this.handleCancelImportModal()
      this.$buefy.toast.open(this.$t('messages.save_success'))
    })
  }
}
</script>
